import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import React from "react";
import "./index.css";
import "animate.css";

import OrdersNotification from "./components/OrdersNotification/OrdersNotification";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { store } from "./redux/store/index";
import App from "./containers/App/App";

createRoot(document.getElementById("app")).render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <HelmetProvider>
          <App />
        </HelmetProvider>
        <OrdersNotification />
        <Toaster />
      </Router>
    </Provider>
  </React.StrictMode>
);

serviceWorkerRegistration.unregister();
